/** Driving-distance tiers for slot suggestions (miles). */
export const SLOT_PROXIMITY_HIGH_MAX_MI = 10;
export const SLOT_PROXIMITY_MID_MAX_MI = 25;

export type SlotProximityTier = 'high' | 'mid' | 'far';

export function proximityTierFromMiles(miles: number): SlotProximityTier {
  if (miles < SLOT_PROXIMITY_HIGH_MAX_MI) return 'high';
  if (miles < SLOT_PROXIMITY_MID_MAX_MI) return 'mid';
  return 'far';
}
